
import React from 'react';
import { Building2 } from 'lucide-react';

export const OrganizationEmptyState = () => {
  return (
    <div className="text-center py-8">
      <Building2 className="h-12 w-12 mx-auto text-muted-foreground mb-4" />
      <h3 className="text-lg font-semibold mb-2">No organizations yet</h3>
      <p className="text-muted-foreground">
        Create your first organization to get started
      </p>
    </div>
  );
};
